export default function getUserName(user, withPrefix = false) {
  if (!user) return null
  let prefix = user.namePrefix
  let name = `${user.nameFirst || ''} ${user.nameLast || ''}`
  return (withPrefix && prefix) ? `${prefix}. ${name}` : name
}